import { Injectable } from "@angular/core";
import { CollectionHandle, Entry, Silo } from "@org-quicko/silo-client";
import { BehaviorSubject, from, Observable } from "rxjs";
import { environment } from '../../environments/environment';

interface CountryReference {
    name: string;
    country_code: string | null;
    numeric_code: number;
    flag: string | null;
    flag_1x1: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class ReferenceService {
    private readonly countriesCollection: CollectionHandle<CountryReference>;
    referenceData: BehaviorSubject<any> | undefined;

    constructor() {
        const silo = new Silo({
            url: environment.silo_url,
            cache: {
                enabled: true,
                ttl: 5 * 60 * 1000,
                maxSize: 1000,
            },
        });
        this.countriesCollection = silo
            .scope('company-quicko', environment.silo_environment)
            .collection<CountryReference>('company-quicko-country');
    }

    /**
     * Reads countries from the shared Company Quicko Silo project.
     * @returns Countries suitable for the phone-number selector.
     */
    getCountries(): Observable<Entry<CountryReference>[]> {
        return from(this.countriesCollection.all({ limit: 300 }).toArray().then((countries) => countries.filter((country) => country.country_code != null)));
    }

}
